exports.default = {
  'not_found_message': 'After searching the entire Earth, we still couldn\'t find the page you were looking for'
}
